import React from 'react';
import PropTypes from 'prop-types';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { Button } from 'site-modules/shared/components/inventory/button/button';

import './error-screen.scss';

const ERROR_LOGO_PATH = '/img/llm-error.svg';

export function ErrorScreen({
  buttonOptions: { buttonDisclaimer, onClick, buttonText } = {},
  heading = '',
  subHeading = '',
  creativeId = undefined,
}) {
  return (
    <div className="error-screen text-center d-flex flex-column pt-2_5" data-tracking-parent={creativeId}>
      {heading && <h2 className="heading-2 mb-1_5 error-screen-heading">{heading}</h2>}
      {subHeading && <div className="size-20 mb-1 error-screen-subheading">{subHeading}</div>}
      <div>
        <img src={getStaticImageUrl(ERROR_LOGO_PATH)} alt="Error logo" className="error-logo" />
      </div>
      {!!buttonDisclaimer && <div className="text-cool-gray-30 mt-1_5">{buttonDisclaimer}</div>}
      {!!onClick && typeof buttonText === 'string' && (
        <div>
          <Button
            color="blue-50"
            className="text-transform-none text-decoration-none size-16 fw-medium mt-1_5 py-0_5 px-1"
            onClick={onClick}
          >
            {buttonText}
          </Button>
        </div>
      )}
    </div>
  );
}

ErrorScreen.propTypes = {
  heading: PropTypes.string,
  subHeading: PropTypes.string,
  buttonOptions: PropTypes.shape({}),
  creativeId: PropTypes.string,
};
